import { livewireModal } from '@js/vendors/livewire/livewireModal';
import { livewireOffcanvas } from '@js/vendors/livewire/livewireOffcanvas';
import { livewireAlert } from '@js/vendors/livewire/livewireAlert';

document.addEventListener('livewire:init', () => {
    // Runs after Livewire is loaded but before it's initialized
    // on the page...
    livewireModal();
    livewireOffcanvas();
    livewireAlert();
});

document.addEventListener('livewire:initialized', () => {
    // Runs immediately after Livewire has finished initializing
    // on the page...

    console.log('Livewire initialized');

    window.Livewire.on('livewire.component.rendered', (data) => {
        const { name } = data[0];

        setTimeout(() => {
            window.dispatchEvent(new CustomEvent('livewire.component.rendered'));
            window.dispatchEvent(new CustomEvent(`livewire.component.rendered.${name}`));
        }, 0);
    });

    window.Livewire.on('show-flash-message', (payload) => {
        const data = payload?.[0];

        window.flashMessage(data);
    });
});
